export const DEFAULT_ATTENDANCE_MODE = "Remote";
  
  export const attendanceMode = [
    "Remote",
    "F2F Front",
    "F2F Rear",
  ];
  